import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      border: `1px solid ${COLORS.success.light}`,
      backgroundColor: COLORS.neutral.white,
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0px 4px 12px 0px rgba(0,0,0, 0.1)',
      padding: theme.spacing(2),
      rowGap: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
      alignItems: 'center',
      width: 407,
    },
    blockedScoreIcon: {
      width: 74,
      height: 49.5,
    },
    blockedReason: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(19),
      textAlign: 'center',
      whiteSpace: 'pre-line',
    },
    upgrade: {
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(0, 2),
      height: 26,
    },
    buttonUndo: {
      minWidth: 'auto',
      padding: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(10),
      lineHeight: 1.2,
      color: COLORS.neutral.mediumGray,
      textDecoration: 'none',

      '&:focus:enabled': {
        color: COLORS.neutral.mediumGray,
      },
      '&:hover:enabled': {
        color: COLORS.primary.default,
      },
      '&[disabled]': {
        color: theme.palette.action.disabled,
      },
    },
  }),
  { name: 'BlockedMessage' }
);
